import { render, staticRenderFns } from "./PageShareForm.vue?vue&type=template&id=2fecc123&scoped=true&"
import script from "./PageShareForm.vue?vue&type=script&lang=js&"
export * from "./PageShareForm.vue?vue&type=script&lang=js&"
import style0 from "./PageShareForm.vue?vue&type=style&index=0&id=2fecc123&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fecc123",
  null
  
)

export default component.exports